import distCluster from '@/assets/images/map/distCluster.png'
import api from '../../api'
import dayjs from 'dayjs'
import energyOnline from '@/assets/images/map/eneregy-online.png'
import energy from '@/assets/images/map/energy.png'
import heavy from '@/assets/images/map/heavy.png'
import heavyOnline from '@/assets/images/map/heavy-online.png'

export default {
  data () {
    return {
      map: null,
      pointSimplifierIns: null,
      distCluster: null,
      heatMap01: null,
      heatMap02: null,
      marker: null,
      govNow: '',
      // 可能只是用来保存值的
      govList: [],
      // 充电热力图对应的选中值
      govNow1: '',
      // 充电热力对应的选项
      govList1: [],
      // 轨迹热力图对应的选中值
      govNow2: '',
      // 轨迹热力对应的选项
      govList2: [],

      geoData: [],
      markerArr: {
        arr: [],
        push (data) {
          this.arr.push(data)
        },
        show () {
          this.arr.forEach(item => {
            item.show()
          })
        },
        hide () {
          this.arr.forEach(item => {
            item.hide()
          })
        }
      },
      mapLoad: true,
      energyOnline: energyOnline,
      energy: energy,
      heavy: heavy,
      heavyOnline: heavyOnline,
      queryDisable: true
    }
  },
  computed: {
    carList () {
      if (!this.input) return []
      const type = this.value === '1' ? 'licensePlate' : 'vin'
      return this.geoData.filter(d => (d[type] || '').includes(this.input)).map(d => d[type])
    }
  },
  mounted () {
    this.initMap()
  },
  methods: {
    // 初始化地图
    initMap () {
      const self = this
      const AMap = window.AMap
      const AMapUI = window.AMapUI
      this.map = new AMap.Map('homeMap-map', {
        zoom: 4,
        center: [106.397428, 37.90923],
        mapStyle: 'amap://styles/darkblue',
        viewMode: '2D'
      })
      // pointSimplifier 海量点展示ui组件
      AMapUI.load(['ui/misc/PointSimplifier', 'ui/geo/DistrictCluster'], function (PointSimplifier, DistrictCluster) {
        // 启动页面
        self.initPoints(PointSimplifier)
        self.initDistCluster(DistrictCluster)
        self.setZoomEvent()
        self.setMapData().then(() => {
          self.map.plugin(['AMap.Heatmap'], function () {
            self.heatmap01()
            self.heatmap02()
            self.setHeatData()
          })
        })
      })
    },
    // 地图打点的通用实例
    getPointSimplifierIns (PointSimplifier) {
      const energyOnline = PointSimplifier.Render.Canvas.getImageContent(this.energyOnline, () => {
        this.pointSimplifierIns.renderLater()
      })
      const energy = PointSimplifier.Render.Canvas.getImageContent(this.energy, () => {
        this.pointSimplifierIns.renderLater()
      })
      const heavy = PointSimplifier.Render.Canvas.getImageContent(this.heavy, () => {
        this.pointSimplifierIns.renderLater()
      })
      const heavyOnline = PointSimplifier.Render.Canvas.getImageContent(this.heavyOnline, () => {
        this.pointSimplifierIns.renderLater()
      })
      return new PointSimplifier({
        map: this.map, // 所属的地图实例
        autoSetFitView: false, // 自动更新地图视野
        zIndex: 800,
        getPosition: function (item) {
          if (!item) {
            return null
          }
          return [item.lon, item.lat]
        },
        getHoverTitle: function (dataItem, idx) {
          return dataItem.licensePlate
        },
        // 使用GroupStyleRender
        renderConstructor: PointSimplifier.Render.Canvas.GroupStyleRender,
        renderOptions: {
          // 点的样式
          pointStyle: {
            width: 22,
            height: 26,
            // content: content01,
            fillStyle: 'rgba(153, 0, 153, 0.38)'
          },
          pointHardcoreStyle: {
            width: 0,
            height: 0
          },
          getGroupId: function (item) {
            // 新能源车
            if (item.protocalType === 5) {
              // 在线
              if (item.status === 1) {
                return 0
              } else {
                return 1
              }
            }
            // 燃油车
            if (item.protocalType === 6) {
              if (item.status === 1) {
                return 2
              } else {
                return 3
              }
            }
          },
          groupStyleOptions: function (gid) {
            // let arr = ['rgb(33, 213, 171)', 'rgb(0, 192, 255)', 'rgb(243, 218, 79)', 'rgb(255, 0, 0)']
            let icon = [energyOnline, energy, heavyOnline, heavy]
            return {
              pointStyle: {
                // width: 50,
                // height: 50,
                content: icon[gid]
                // fillStyle: icon[gid - 1]
              }
            }
          },
          pointHoverStyle: {
            lineWidth: 0,
            strokeStyle: 'rgba(0,0,0,0)'
          },
          // 鼠标hover时的title信息
          hoverTitleStyle: {
            position: 'top'
          }
        }
      })
    },
    // 实时监控打点
    initPoints (PointSimplifier) {
      const self = this
      this.pointSimplifierIns = this.getPointSimplifierIns(PointSimplifier)
      this.pointSimplifierIns.on('pointClick', (e, record) => {
        self.$router.push({
          name: 'detailsContainer',
          params: {
            licensePlate: record.data.licensePlate
          },
          query: {
            vid: record.data.vid,
            vinIng: record.data.vin,
            protocalType: record.data.protocalType
          }
        })
        // detailsContainer/:licensePlate
      })
      this.pointSimplifierIns.hide()
    },
    // 聚合
    initDistCluster (DistrictCluster) {
      const AMap = window.AMap
      const self = this
      const map = this.map
      this.distCluster = new DistrictCluster({
        zIndex: 300,
        map: map, // 所属的地图实例
        getPosition: function (item) {
          if (!item) {
            return null
          }
          // 返回经纬度
          return [item.lon, item.lat]
        },
        autoSetFitView: false,
        // 使用自定义的引擎类
        // renderConstructor: MyRender,
        renderOptions: {
          // 基础样式
          featureStyle: {
            fillStyle: 'rgba(102,170,0,0)', // 填充色
            lineWidth: 2, // 描边线宽
            strokeStyle: 'rgba(31, 119, 180,0)', // 描边色
            // 鼠标Hover后的样式
            hoverOptions: {
              fillStyle: 'rgba(255,255,255,0)'
            }
          },
          // 特定区划级别的默认样式
          featureStyleByLevel: {
            // 全国
            country: {
              fillStyle: 'rgba(43, 173, 202, .4)'
            },
            // 省
            province: {
              fillStyle: 'rgba(43, 173, 202, .4)'
            },
            // 市
            city: {
              fillStyle: 'rgba(43, 173, 202, .4)'
            },
            // 区县
            district: {
              fillStyle: 'rgba(43, 173, 202, .4)'
            }
          },
          getFeatureStyle: function (feature, dataItems) {
            var style = [{
              fillStyle: 'rgba(113,79,255,0.5)',
              lineWidth: 2, // 描边线宽
              strokeStyle: 'rgb(31, 119, 180)'
            }, {
              fillStyle: 'rgba(47,164,229,.4)',
              lineWidth: 2, // 描边线宽
              strokeStyle: 'rgb(31, 119, 180)'
            }, {
              fillStyle: 'rgba(64,128,164,0.5)',
              lineWidth: 2, // 描边线宽
              strokeStyle: 'rgb(31, 119, 180)'
            }]
            var n = 1
            // dataItems.length > 200 ? dataItems.length > 400 ? n = 0 : n = 1 : n = 2;
            return style[n]
          },
          // 不再使用聚合标注
          // getClusterMarker: null,
          // getClusterMarkerPosition: DistrictCluster.ClusterMarkerPositionStrategy.AVERAGE_POINTS_POSITION,
          getClusterMarker: function (feature, dataItems, recycledMarker) {
            var zoom = map.getZoom()
            if (zoom > 7) return

            const list = self.govList
            // const total = self.dataList.total
            var text = feature.properties.name
            var listNum = false
            var inList = list.some(function (t, i) {
              if (t.name.substring(0, 2) === text.substring(0, 2)) {
                listNum = i
                return true
              }
              return false
            })

            // if((listNum === false || !list[listNum].total) && !dataItems.length)return;
            if ((listNum === false || !list[listNum].totalCarCount)) return

            var online = 0
            dataItems.forEach(function (t) {
              if (t.dataItem.status !== 3) {
                online++
              }
            })

            // 这里是用了数据库的数据
            var text2 = inList ? `(${list[listNum].onlineCarCount}/${list[listNum].totalCarCount})` : '(' + online + '/' + dataItems.length + ')'
            // if ((listNum === false || !list[listNum].totalCarCount)) return;
            // if (dataItems.length == 0) return;
            var dom = `<div class='map_label'><img class='map_lableImg' alt='' src='${distCluster}'><div class='map_labelCon'><p class='map_labelP'>${text}</p><p class='map_labelP'>${text2}</p></div></div>`

            var marker = new AMap.Marker({
              // icon: cityBgStr02,
              content: dom,
              zIndex: 500,
              offset: {
                x: -64,
                y: -66
              }
            })
            self.markerArr.push(marker)
            return marker
          },
          // 点击区划面后切换到子级区划
          featureClickToShowSub: false
        }

      })
      this.distCluster.on('clusterMarkerClick', function (e, record) {
        // let name = record.feature.properties.name
        // let center = setCity(name)console
        // console.log(name)
        // map.setCity(name)
        map.setZoom(10)
        // map.setZoomAndCenter(10, center)
      })
    },
    // 热力图1
    heatmap01 () {
      // 初始化heatmap对象
      this.heatMap01 = new window.AMap.Heatmap(this.map, {
        radius: 25, // 给定半径
        opacity: [0, 0.8]
      })
      this.heatMap01.hide()
    },
    // 热力图2
    heatmap02 () {
      // 初始化heatmap对象
      this.heatMap02 = new window.AMap.Heatmap(this.map, {
        radius: 25, // 给定半径
        opacity: [0, 0.8]
      })
      this.heatMap02.hide()
    },
    setZoomEvent () {
      const self = this
      this.map.on('zoomend', function () {
        self.refresh()
      })
    },
    refresh () {
      if (this.isActive !== 0) return
      const map = this.map
      var zoom = map.getZoom()
      if (zoom <= 7) {
        this.pointSimplifierIns.hide()
        this.markerArr.show()
      } else {
        this.pointSimplifierIns.show()
        this.markerArr.hide()
      }
    },
    setMapData (val) {
      const self = this
      const getMapData = async function () {
        const ProCarCount = await api.getProCarCount({
          type: !val ? -1 : val
        })
        const Geo = await api.getGeo()

        self.govList = ProCarCount.data.data
        self.govList1 = ProCarCount.data.data
        self.govList2 = ProCarCount.data.data
        self.govNow = self.govList[0].id
        self.govNow1 = self.govList[0].id
        self.govNow2 = self.govList[0].id
        self.distCluster.setData(self.govList)

        self.geoData = Geo.data.data
        self.pointSimplifierIns.setData(self.geoData)
        self.queryDisable = false

        self.mapLoad = false
      }
      return getMapData()
    },
    // 轨迹热力图
    setHeatData (type) {
      const self = this
      let lastDay = new Date() - 1000 * 60 * 60 * 24
      let date = dayjs(lastDay).format('YYYY-MM-DD')
      // console.log(type)
      const areaId = this.govNow
      const getHeatData = async function () {
        const ChargeGeo = await api.getChargeGeo({
          areaId: areaId,
          date: date
        })
        self.heatMap01.setDataSet({
          data: ChargeGeo.data.data.map(d => {
            return {
              lng: d.wgLon,
              lat: d.wgLat,
              count: 1
            }
          }),
          max: 100
        })
        const RunGeo = await api.getRunGeo({
          areaId: areaId,
          date: date,
          type: !type ? 5 : type
        })
        self.heatMap02.setDataSet({
          data: RunGeo.data.data.map(d => {
            return {
              lng: d.lon,
              lat: d.lat,
              count: d.count
            }
          }),
          max: 100
        })
      }
      getHeatData()
    },
    search (type, inner) {
      let point = null
      console.log(type, inner)
      switch (type) {
        case '1':
          const plateArr = this.geoData.map(d => d.licensePlate)
          const plateIndex = plateArr.indexOf(inner)
          if (plateIndex === -1) {
            this.$message({
              message: '查无此车，请检查您的输入后重新搜索。',
              type: 'success'
            })
            return
          }
          if (plateIndex !== -1) point = this.geoData[plateIndex]
          break
        case '2':
          const vinArr = this.geoData.map(d => d.vin)
          console.log(vinArr)
          const vinIndex = vinArr.indexOf(inner)
          console.log(vinIndex)
          if (vinIndex === -1) {
            this.$message({
              message: '查无此车，请检查您的输入后重新搜索。',
              type: 'success'
            })
            return
          }
          if (vinIndex !== -1) point = this.geoData[vinIndex]
          break
      }
      if (!point) return
      const AMap = window.AMap
      this.map.setZoomAndCenter(10, [point.lon, point.lat])
      var icon = new AMap.Icon({
        image: 'http://vdata.amap.com/icons/b18/1/2.png',
        size: new AMap.Size(24, 24)
      })
      this.marker && this.marker.hide()
      this.marker = new AMap.Marker({
        icon: icon,
        position: [point.lon, point.lat],
        offset: new AMap.Pixel(-12, -26),
        zIndex: 10000,
        animation: 'AMAP_ANIMATION_BOUNCE',
        map: this.map
      })
    },
    // 动力方式变更
    changePowerMode (val) {
      this.changeMapMarker()
      api.getProCarCount({
        type: !val ? -1 : val
      }).then((ProCarCount) => {
        this.govList = ProCarCount.data.data
        this.govList1 = ProCarCount.data.data
        this.govList2 = ProCarCount.data.data
        this.govNow = this.govList[0].id
        this.govNow1 = this.govList[0].id
        this.govNow2 = this.govList[0].id
        this.distCluster.setData(this.govList)
        this.mapLoad = false
      })
    },
    // 更改地图上的点
    changeMapMarker () {
      let arr = []
      console.log('车类型：' + this.protocalType)
      console.log('地图点的数量: ' + this.geoData.length)
      this.geoData.map((item) => {
        if (item.protocalType === Number(this.protocalType)) {
          arr.push(item)
        }
      })
      console.log('长度：' + arr.length)
      this.pointSimplifierIns.setData(arr)
    }
  },
  watch: {
    isActive (val) {
      switch (val) {
        case 0:
          this.heatMap01 && this.heatMap01.hide()
          this.heatMap02 && this.heatMap02.hide()
          this.pointSimplifierIns && this.pointSimplifierIns.show()
          this.distCluster && this.distCluster.show()
          this.refresh()
          break
          // 轨迹热力
        case 1:
          this.pointSimplifierIns && this.pointSimplifierIns.hide()
          this.distCluster && this.distCluster.hide()
          this.heatMap02 && this.heatMap02.hide()
          this.heatMap01 && this.heatMap01.show()
          break
          // 充电热力
        case 2:
          this.pointSimplifierIns && this.pointSimplifierIns.hide()
          this.distCluster && this.distCluster.hide()
          this.heatMap01 && this.heatMap01.hide()
          this.heatMap02 && this.heatMap02.show()
          break
        case 3:
          this.pointSimplifierIns && this.pointSimplifierIns.hide()
          this.distCluster && this.distCluster.hide()
          this.heatMap01 && this.heatMap01.hide()
          this.heatMap02 && this.heatMap02.show()
          break
      }
    },
    govNow1 (val) {
      if (!this.govList[0]) return
      let lastDay = new Date() - 1000 * 60 * 60 * 24
      let date = dayjs(lastDay).format('YYYY-MM-DD')
      api.getChargeGeo({
        areaId: val,
        date: date
      }).then(resp => {
        this.heatMap01.setDataSet({
          data: resp.data.data.map(d => {
            return {
              lng: d.wgLon,
              lat: d.wgLat,
              count: 1
            }
          }),
          max: 100
        })
      })
      const cityName = this.govList.filter(d => d.id === val)[0].name
      this.map.setCity(cityName)
    },
    govNow2 (val, type) {
      if (!this.govList[0]) return
      let lastDay = new Date() - 1000 * 60 * 60 * 24
      let date = dayjs(lastDay).format('YYYY-MM-DD')
      api.getRunGeo({
        areaId: val,
        date: date,
        type: !type ? 5 : type
      }).then(resp => {
        this.heatMap02.setDataSet({
          data: resp.data.data.map(d => {
            return {
              lng: d.lon,
              lat: d.lat,
              count: d.count
            }
          }),
          max: 100
        })
      })
      const cityName = this.govList.filter(d => d.id === val)[0].name
      this.map.setCity(cityName)
    }
  }
}
